import actions from './actions';

const initState = {
  apiKeys: [],
  total: 0,
  loading: false,
  error: '',
  lastUpdated: null,
};

export default function apiKeysReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_API_KEYS:
    case actions.CREATE_API_KEY:
    case actions.UPDATE_API_KEY:
    case actions.DELETE_API_KEY:
    case actions.REGENERATE_API_KEY:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case actions.GET_API_KEYS_SUCCESS:
      return {
        ...state,
        apiKeys: action.apiKeys,
        total: action.total,
        loading: false,
        error: '',
        lastUpdated: new Date().toISOString(),
      };

    case actions.CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: [...state.apiKeys, action.apiKey],
        loading: false,
        error: '',
      };

    case actions.UPDATE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: state.apiKeys.map(key =>
          key.id === action.apiKey.id ? action.apiKey : key
        ),
        loading: false,
        error: '',
      };

    case actions.REGENERATE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: state.apiKeys.map(key =>
          key.id === action.apiKey.id ? action.apiKey : key
        ),
        loading: false,
        error: '',
      };

    case actions.DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: state.apiKeys.filter(key => key.id !== action.keyId),
        loading: false,
        error: '',
      };

    case actions.GET_API_KEYS_ERROR:
    case actions.CREATE_API_KEY_ERROR:
    case actions.UPDATE_API_KEY_ERROR:
    case actions.DELETE_API_KEY_ERROR:
    case actions.REGENERATE_API_KEY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.CLEAR_API_KEYS_ERROR:
      return {
        ...state,
        error: '',
      };

    default:
      return state;
  }
}
